export const assessQuestion = ({
  questionBankId,
  questionId,
  boxId,
  workoutStore,
  userResponseStore,
}) => {
  // fire off stuff from each store! is this ideal?
  workoutStore.setQuestionResponse({ questionBankId, questionId, boxId })
  userResponseStore.setQuestionResponse({ questionBankId, questionId, boxId })
}



// WEBPACK FOOTER //
// ./src/store/actions.js